import React from 'react';
import { Spinner, ErrorAlert } from '../../../components/shared';
import { cn } from '../../../utils/cn';
import useOrders from '../hooks/useOrders';
import OrderRow from './OrderRow';
import OrderDetail from './OrderDetail';

const STATUS_FILTERS = [
  { key: null, label: 'Tất cả' },
  { key: 'PENDING,OPEN', label: 'Đang xử lý' },
  { key: 'FILLED', label: 'Hoàn thành' },
  { key: 'CANCELLED,REJECTED', label: 'Đã hủy' },
];

export default function OrdersTab() {
  const {
    orders,
    pagination,
    filters,
    selectedOrder,
    loading,
    detailLoading,
    error,
    updateFilters,
    changePage,
    selectOrder,
    clearSelection,
    approveOrder,
    confirmPayment,
    openWebview,
    syncOrderStatus,
  } = useOrders();

  return (
    <div className="space-y-4">
      <div className="flex gap-2 overflow-x-auto">
        {STATUS_FILTERS.map((sf) => (
          <button
            key={sf.key || 'all'}
            type="button"
            onClick={() => updateFilters({ status: sf.key })}
            className={cn(
              'whitespace-nowrap rounded-full px-3 py-1.5 text-xs font-medium transition-colors',
              filters.status === sf.key
                ? 'bg-blue-600 text-white'
                : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
            )}
          >
            {sf.label}
          </button>
        ))}
      </div>

      <ErrorAlert error={error} />

      {loading ? (
        <div className="flex justify-center py-12">
          <Spinner size="lg" />
        </div>
      ) : orders.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-16 text-center">
          <svg className="mb-3 h-12 w-12 text-gray-300" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
          <p className="text-sm text-gray-500">Chưa có lệnh nào</p>
        </div>
      ) : (
        <>
          <div className="space-y-3">
            {orders.map((order) => (
              <OrderRow
                key={order.id}
                order={order}
                onClick={() => selectOrder(order.id)}
                onOpenWebview={openWebview}
                onSyncStatus={syncOrderStatus}
              />
            ))}
          </div>

          {pagination.totalPages > 1 && (
            <div className="flex items-center justify-between pt-2">
              <button
                type="button"
                disabled={pagination.page <= 0}
                onClick={() => changePage(pagination.page - 1)}
                className="rounded-lg border border-gray-200 px-3 py-1.5 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-40"
              >
                Trước
              </button>
              <span className="text-xs text-gray-500">
                Trang {pagination.page + 1} / {pagination.totalPages}
              </span>
              <button
                type="button"
                disabled={pagination.page >= pagination.totalPages - 1}
                onClick={() => changePage(pagination.page + 1)}
                className="rounded-lg border border-gray-200 px-3 py-1.5 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-40"
              >
                Tiếp
              </button>
            </div>
          )}
        </>
      )}

      {selectedOrder && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4" onClick={clearSelection}>
          <div className="w-full max-w-lg" onClick={(e) => e.stopPropagation()}>
            {detailLoading ? (
              <div className="flex items-center justify-center rounded-2xl bg-white py-16 shadow-xl">
                <Spinner size="lg" />
              </div>
            ) : (
              <OrderDetail
                order={selectedOrder}
                onClose={clearSelection}
                onApprove={approveOrder}
                onConfirmPayment={confirmPayment}
                actionLoading={detailLoading}
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
}
